import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import RemoveDownloadManager from "../UseCase/RemoveDownloadManager";
import getDatabase from "./database";

const removeDownloadManager: RemoveDownloadManager = new RemoveDownloadManager(
    new DownloadManagerRepository(getDatabase())
);

export default function getRemoveDownloadManager(): RemoveDownloadManager {
    return removeDownloadManager;
};